import { useState } from 'react';
import { useForm } from 'react-hook-form';

import Button from '../components/elements/Button';
import Label from '../components/elements/Forms/Label';
import TextInput from '../components/elements/Forms/TextInput';
import Heading2 from '../components/elements/Heading/Heading2';
import Link from '../components/elements/Link';
import Paragraph from '../components/elements/Paragraph';
import BasicCardLayout from '../components/modules/Layout/BasicLayout/BasicCardLayout';
import Seo from '../components/modules/Seo';
import SuccessAction from '../components/modules/SuccessAction';
import routes from '../config/routes';
import { sendMagicLink } from '../features/auth';

interface FormFields {
    email: string;
}

interface MagicLinkProps {}

export default function MagicLink({}: MagicLinkProps): JSX.Element {
    const [isSuccess, setIsSuccess] = useState<boolean | undefined>(undefined);
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm<FormFields>();

    async function onSubmit(data: FormFields): Promise<void> {
        setIsSuccess(undefined);
        try {
            await sendMagicLink(data.email);
            setIsSuccess(true);
        } catch (error) {
            setIsSuccess(false);
        }
    }

    if (isSuccess === true) {
        return (
            <BasicCardLayout>
                <Seo
                    title="Demande de lien de connexion"
                    description="Nous vous envoyons un e-mail avec un lien pour vous connecter sans mot de passe sur Partager."
                    url={routes.login.getUrl()}
                    isCanonical
                />
                <SuccessAction
                    headerTitle="E-mail envoyé !"
                    text="L'e-mail contenant un lien de connexion a été envoyé."
                />
            </BasicCardLayout>
        );
    }

    return (
        <BasicCardLayout>
            <Seo
                title="Demande de lien de connexion"
                description="Nous vous envoyons un e-mail avec un lien pour vous connecter sans mot de passe sur Partager."
                url={routes.login.getUrl()}
            />
            <Heading2 className="!mt-0" level={1}>
                Demande de lien de connexion
            </Heading2>
            <Paragraph className="mb-6">
                Entrer votre adresse e-mail et nous vous enverrons un lien pour vous connecter à
                votre compte.
            </Paragraph>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="mb-6">
                    <Label htmlFor="email">Adresse e-mail</Label>
                    <TextInput
                        name="email"
                        id="email"
                        type="email"
                        className="w-full"
                        register={register}
                        errorText={errors.email?.message}
                    />
                </div>
                <Button type="submit" className="!w-full mb-6">
                    Envoyer un lien de connexion
                </Button>
                {isSuccess === false && (
                    <Paragraph variant="error">
                        Une erreur s&apos;est produite, veuillez réessayer
                    </Paragraph>
                )}
            </form>
            <div className="text-center">
                <Link href={routes.login.getUrl()}>Annuler</Link>
            </div>
        </BasicCardLayout>
    );
}
